import React, { useMemo } from 'react';
import PartyLedgerPage from './PartyLedgerPage';
import { createBorrower, deleteBorrower, getBorrowers, updateBorrower } from '../api/borrowerApi';

const BorrowerPage = () => {
  const introText = useMemo(
    () =>
      'Monitor every borrower, the exposure you hold, and the description of why the funds were extended.',
    []
  );

  const apiClient = useMemo(
    () => ({
      fetchAll: getBorrowers,
      create: createBorrower,
      update: updateBorrower,
      remove: deleteBorrower
    }),
    []
  );

  return <PartyLedgerPage partyLabel="Borrower" introText={introText} apiClient={apiClient} />;
};

export default BorrowerPage;
